import { useEffect } from 'react';
import { useInstanceId } from 'shared/src/hooks';
import { bridge, isApp } from 'shared/src/utils';

export const useReportTTFD = () => {
  const instanceId = useInstanceId();

  useEffect(() => {
    if (!instanceId) {
      return;
    }
    if (isApp()) {
      bridge.reportTTFD({ instanceId });
    }
  }, [instanceId]);
};
